export interface Operation {
  name: string;
  label: string;
  description?: string;
  helperText?: string;
  needsValue?: boolean;
  hasMultipleValues?: boolean;
  output: string;
}

const stringOperations: Operation[] = [
  {
    name: "concatenate",
    label: "Concatenar",
    description: "concatenate",
    helperText: "Unir dos o mas cadenas de texto en una sola",
    hasMultipleValues: true,
    output: "string",
  },
  {
    name: "replace",
    label: "Reemplazar",
    description: "replace",
    helperText: "Reemplaza la primera instancia de un texto por otro",
    needsValue: true,
    output: "string",
  },
  {
    name: "replace_all",
    label: "Reemplazar todo",
    description: "replaceAll",
    helperText: "Reemplaza todas las instancias de un texto por otro",
    needsValue: true,
    output: "string",
  },
  {
    name: "slice",
    label: "Extraer texto desde índice",
    description: "slice",
    helperText:
      "Devuelve parte del texto desde un indice inicial hasta el final o uno final",
    needsValue: true,
    output: "string",
  },
  {
    name: "trim",
    label: "Quitar espacios a los extremos",
    description: "trim",
    helperText: "Elimina espacios en blanco al inicio y al final",
    output: "string",
  },
  {
    name: "to_upper_case",
    label: "Convertir a mayúsculas",
    description: "toUpperCase",
    helperText: "Devuelve el texto en mayúsculas",
    output: "string",
  },
  {
    name: "to_lower_case",
    label: "Convertir a minúsculas",
    description: "toLowerCase",
    helperText: "Devuelve el texto en minúsculas",
    output: "string",
  },
  {
    name: "string_length",
    label: "Obtener longitud del texto",
    description: "length",
    helperText: "Devuelve la cantidad de caracteres",
    output: "number",
  },
  {
    name: "repeat",
    label: "Repetir texto",
    description: "repeat",
    helperText: "Crea una nueva cadena repitiendo la original",
    needsValue: true,
    output: "string",
  },
  {
    name: "split",
    label: "Dividir texto por separador",
    description: "split",
    helperText: "Convierte un string en array usando un delimitador",
    needsValue: true,
    output: "array",
  },
];

const numberOperations: Operation[] = [
  {
    name: "add",
    label: "Suma",
    description: "sum(+)",
    helperText: "Suma dos o más números",
    hasMultipleValues: true,
    output: "number",
  },
  {
    name: "subtract",
    label: "Resta",
    description: "subtract(-)",
    helperText: "Resta dos o más números",
    hasMultipleValues: true,
    output: "number",
  },
  {
    name: "multiply",
    label: "Multiplicar",
    description: "multiply(*)",
    helperText: "Multiplica dos o más números",
    hasMultipleValues: true,
    output: "number",
  },
  {
    name: "divide",
    label: "Dividir",
    description: "divide(/)",
    helperText: "Divide dos o más números",
    hasMultipleValues: true,
    output: "number",
  },
  {
    name: "power",
    label: "Potenciar",
    description: "power(**)",
    helperText: "Eleva un número a una potencia",
    needsValue: true,
    output: "number",
  },
  {
    name: "sqrt",
    label: "Raíz cuadrada",
    description: "sqrt",
    helperText: "Devuelve la raíz cuadrada",
    output: "number",
  },
  {
    name: "abs",
    label: "Valor absoluto",
    description: "abs",
    helperText: "Devuelve el valor positivo",
    output: "number",
  },
  {
    name: "round",
    label: "Redondear",
    description: "round",
    helperText: "Redondea al decimal especificado",
    needsValue: true,
    output: "number",
  },
  {
    name: "ceil",
    label: "Redondear hacia arriba",
    description: "ceil",
    helperText: "Redondear al decimal especificado superior",
    needsValue: true,
    output: "number",
  },
  {
    name: "floor",
    label: "Redondear hacia abajo",
    description: "floor",
    helperText: "Redondear al decimal especificado inferior",
    needsValue: true,
    output: "number",
  },
  {
    name: "truncate",
    label: "Truncar",
    description: "truncate",
    helperText: "Eliminar decimales sin redondear",
    output: "number",
  },
  {
    name: "log10",
    label: "Logaritmo",
    description: "log",
    helperText: "Logaritmo base 10.",
    output: "number",
  },
  {
    name: "ln",
    label: "Logaritmo natural",
    description: "ln",
    helperText:
      "Devuelve el exponente necesario para obtener el valor dado usando el número de Euler.",
    needsValue: true,
    output: "number",
  },
  {
    name: "exp",
    label: "Exponencial",
    description: "exp",
    helperText: "Eleva el número de Euler a la potencia del número dado.",
    needsValue: true,
    output: "number",
  },
  {
    name: "number_to_string",
    label: "Formatear a string",
    description: "numberToString",
    helperText: "Convierte número a texto.",
    output: "string",
  },
];

const dateOperations: Operation[] = [
  {
    name: "date_add",
    label: "Sumar tiempo",
    description: "add",
    helperText: "Suma la cantidad de tiempo especificada",
    needsValue: true,
    output: "date",
  },
  {
    name: "date_subtract",
    label: "Restar tiempo",
    description: "subtract",
    helperText: "Resta la cantidad de tiempo especificada",
    needsValue: true,
    output: "date",
  },
  {
    name: "date_diff",
    label: "Diferencia de fechas",
    description: "dateDiff",
    helperText: "Devuelve la diferencia entre fechas en horas",
    needsValue: true,
    output: "number",
  },
  {
    name: "date_get_format",
    label: "Extraer tiempo",
    description: "get",
    helperText: "Devuelve el tiempo extraído según el formato elegido",
    output: "string",
  },
  {
    name: "date_to_string",
    label: "Formatear a string",
    description: "toString",
    helperText: "Convierte la fecha a texto según el formato elegido.",
    output: "string",
  },
  {
    name: "date_to_words",
    label: "Convertir fecha a palabras",
    description: "toWords",
    helperText: "Convierte la fecha a texto en palabras.",
    output: "string",
  },
  {
    name: "datetime_to_words",
    label: "Convertir fecha y hora a palabras",
    description: "toWords",
    helperText: "Convierte la fecha y hora a texto en palabras.",
    output: "string",
  },
];

const booleanOperations: Operation[] = [
  {
    name: "not",
    label: "Invertir valor",
    description: "not(!)",
    helperText: "Invierte el valor booleano",
    output: "boolean",
  },
  {
    name: "and",
    label: "AND",
    description: "and(&&)",
    helperText: "Devuelve true si ambos son true",
    needsValue: true,
    output: "boolean",
  },
  {
    name: "or",
    label: "OR",
    description: "or(||)",
    helperText: "Devuelve true si al menos uno es true",
    needsValue: true,
    output: "boolean",
  },
  {
    name: "xor",
    label: "XOR",
    description: "xor",
    helperText: "Devuelve true si solo un valor es true",
    needsValue: true,
    output: "boolean",
  },
  {
    name: "nand",
    label: "NAND",
    description: "nand",
    helperText: "Devuelve false solo si ambos valores son true",
    needsValue: true,
    output: "boolean",
  },
  {
    name: "nor",
    label: "NOR",
    description: "nor",
    helperText: "Devuelve true solo si ambos valores son false",
    needsValue: true,
    output: "boolean",
  },
  {
    name: "xnor",
    label: "XNOR",
    description: "xnor",
    helperText: "Devuelve true si ambos valores son iguales",
    needsValue: true,
    output: "boolean",
  },
  {
    name: "boolean_to_number",
    label: "Convertir a número",
    description: "toNumber",
    helperText: "Convierte el valor a número (1 o 0)",
    output: "number",
  },
  {
    name: "boolean_to_string",
    label: "Convertir a texto",
    description: "toString",
    helperText: "Convertir el valor a texto",
    output: "string",
  },
];

const arrayOperations: Operation[] = [
  {
    name: "array_pop",
    label: "Quitar último elemento",
    description: "pop",
    helperText: "Elimina el último valor del array",
    output: "array",
  },
  {
    name: "array_shift",
    label: "Quitar primer elemento",
    description: "shift",
    helperText: "Elimina el primer valor del array",
    output: "array",
  },
  {
    name: "array_splice",
    label: "Eliminar en índice",
    description: "splice",
    helperText: "Elimina el elemento en el índice especificado",
    needsValue: true,
    output: "array",
  },
  {
    name: "array_sort_asc",
    label: "Ordenar",
    description: "sortAsc",
    helperText: "Organiza los valores en orden alfabético (A->Z)",
    output: "array",
  },
  {
    name: "array_sort_desc",
    label: "Ordenar al revés",
    description: "sortDesc",
    helperText: "Organiza los valores en orden alfabético (Z->A)",
    output: "array",
  },
  {
    name: "array_reverse",
    label: "Invertir orden",
    description: "reverse",
    helperText: "Invierte el orden actual de los elementos en el array",
    output: "array",
  },
  {
    name: "array_map", //special case having two conditions in two rows
    label: "Recorrer y transformar",
    description: "map",
    helperText:
      "Aplica una acción a los elementos que cumplan con la condición",
    needsValue: true,
    output: "array",
  },
  {
    name: "array_filter",
    label: "Filtrar",
    description: "filter",
    helperText: "Devuelve los elementos que cumplen con una condición",
    needsValue: true,
    output: "array",
  },
  {
    name: "array_reduce",
    label: "Reducir",
    description: "reduce",
    helperText: "Transforma el array en un string separado por comas",
    output: "string",
  },
  {
    name: "array_length",
    label: "Obtener tamaño",
    description: "length",
    helperText: "Devuelve cuántos elementos hay en el array",
    output: "number",
  },
  {
    name: "array_index_of",
    label: "Buscar índice",
    description: "indexOf",
    helperText: "Devuelve la posición del texto buscado",
    needsValue: true,
    output: "number",
  },
  {
    name: "array_filter_length",
    label: "Buscar ocurrencias",
    description: "filterLength",
    helperText: "Cuenta cuantas veces aparece un texto en el array",
    needsValue: true,
    output: "number",
  },
  {
    name: "array_trim",
    label: "Recortar",
    description: "trim",
    helperText: "Reduce el array a los elementos seleccionados",
    needsValue: true,
    output: "array",
  },
  {
    name: "array_chunk",
    label: "Dividir en partes",
    description: "chunk",
    helperText: "Devuelve el array en subarrays",
    needsValue: true,
    output: "array",
  },
  {
    name: "array_unique",
    label: "Eliminar duplicados",
    description: "set",
    helperText: "Elimina los elementos repetidos",
    output: "array",
  },
];

export const Operations = {
  string: stringOperations,
  float: numberOperations,
  number: numberOperations,
  date: dateOperations,
  boolean: booleanOperations,
  array: arrayOperations,
  select: [],
  file: [],
};
